/**
 * Constants for the targeted support overview feature.
 * Contains default data for outcomes, guardrails, and configuration.
 */
import type { SidebarItem, Tab } from "./types";

/**
 * Default home tab configuration
 */
export const HOME_TAB: Tab = { id: "home", label: "Home", type: "home" };

export const HOME_SIDEBAR_ITEMS: SidebarItem[] = [
  { id: "overview", label: "Overview", icon: "overview" },
  { id: "outcomes", label: "Outcomes", icon: "outcomes" },
  { id: "guardrails", label: "Guardrails", icon: "guardrails" },
  { id: "history", label: "History", icon: "history" },
  { id: "test", label: "Chat", icon: "chat" },
  { id: "benchmark", label: "Evaluation", icon: "benchmark" },
];
